import { Content } from './input.styled';
import { onKeyDown, onPaste } from './input.func';

export const Input = (props) => {
  const { value, onChange, asNumber, minValue = 0, maxValue = 999, ...rest } = props;
  const change = (event) => {
    let val = event.target.value;
    if (asNumber) {
      val = parseInt(val);
      if (Number.isNaN(val)) {
        val = value;
      }
      if (val < minValue) {
        val = minValue;
      }
      if (val > maxValue) {
        val = maxValue;
      }
    }
    onChange(val);
  };

  const other = {};
  if (asNumber) {
    other.onKeyDown = onKeyDown;
    other.onPaste = onPaste;
  }

  return <Content type="text" value={value} onChange={change} {...rest} {...other} />;
};
